import { Children, cloneElement, Component, PropsWithChildren, ReactElement, Ref } from 'react';

// Local Typings
interface Props {
  children: ReactElement<{ ref?: Ref<Node | null> }>;
  onClickOutside: () => void;
}

// Component Definition
class ClickAwayListener extends Component<PropsWithChildren<Props>> {
  // eslint-disable-next-line react/sort-comp
  node: Node | null;

  componentDidMount() {
    document.addEventListener(
      'touchstart',
      this.handleClick,
      false,
    );
    document.addEventListener(
      'mousedown',
      this.handleClick,
      false,
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      'touchstart',
      this.handleClick,
      false,
    );
    document.removeEventListener(
      'mousedown',
      this.handleClick,
      false,
    );
  }

  handleClick = (e: MouseEvent) => {
    const target = e.target as Node | undefined;
    if (target && this.node?.contains(target)) {
      return;
    }

    this.props.onClickOutside();
  };

  render() {
    return Children.map(this.props.children,
      child =>
        cloneElement(child,
          {
            ref: node => {
              // Keep your own reference
              this.node = node;

              // Call the original ref, if any
              const { ref } = child.props;

              if (typeof ref === 'function') {
                ref(node);
              }
            },
          }));
  }
}

export default ClickAwayListener;
